import { styled } from "@mui/material";

export const ContainerWallet = styled("div")(() => ({
  border: "1px solid #111111",
  backgroundColor: "#111111",
  width: "300px",
  padding: "24px 16px",
  borderRadius: "8px",
  margin: "0 auto",
  marginTop: "40px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "8px",
  alignItems: "center",
  color: "#FFFFFF",
}));

export const ContainerHomeStyled = styled("div")(() => ({
  padding: 0,
  marginTop: 0,
}));

export const ContainerTransactions = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  border: "1px solid #cbcbcb",
  borderRadius: "8px",
  padding: "8px 8px 4px 8px",
  overflow: "hidden",
}));

export const ContainerBalance = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "24px",
  width: "100%",
}));

export const ContainerBalanceItemStyled = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flex: 1,
  gap: "8px",
  padding: "24px",
  border: `1px solid ${theme.palette.grey[1]}`,
  borderRadius: "8px",
  backgroundColor: theme.palette.neutral.white,
  color: theme.palette.neutral.black,
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
}));

export const BalanceText = styled("p")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  margin: 0,
  fontSize: "14px",
  color: "#0197f6",
  span: {
    fontSize: "24px",
    fontWeight: "bold",
  },
}));

export const SelectedCryptoStyled = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  width: "100%",
  border: "1px solid #CBCBCB",
  borderRadius: "8px",
  padding: "8px",
}));

export const CoinText = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
}));

export const ContainerStyled = styled("div")(({ theme }) => ({
  color: "#0F110C",
  borderRadius: "8px",
  padding: "16px",
  backgroundColor: theme.palette.background.default,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
}));

export const ItemContainer = styled("div")(({ isSelected }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  justifyContent: "space-between",
  border: isSelected ? "1px solid #0F110C" : "1px solid #CBCBCB",
  borderRadius: "8px",
  padding: "8px",
  backgroundColor: isSelected ? "#0F110C" : "transparent",
}));

export const ContainerBannerStyled = styled("div")(({ isDesktop }) => ({
  backgroundColor: "#0F110C",
  color: "#EDEDED",
  borderRadius: "8px",
  padding: "16px",
  width: "100%",
  maxWidth: isDesktop ? "350px" : "100%",
  maxHeight: "420px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  gap: isDesktop ? "40px" : "16px",
  position: "relative",
  height: "auto",
  flex: 1,
}));

export const MultiplePaymentDetailStyled = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  padding: "8px",
  border: "1px solid #CBCBCB",
  borderRadius: "8px",
}));
